<mat-drawer-container [hasBackdrop]="false" class="container">
  <mat-drawer #drawer mode="over" position="end" autoFocus="false">
    <mat-toolbar>
      <mat-toolbar-row class="drawer-title-row">
        <span class="drawer-title">{{ title }}</span>
        <button mat-icon-button class="drawer-close-button" (click)="close()">
          <mat-icon>close</mat-icon>
        </button>
      </mat-toolbar-row>
    </mat-toolbar>
    <div class="drawer-content">
      <ng-container #drawerContentRef></ng-container>
    </div>
  </mat-drawer>
  <mat-drawer-content>
    <ng-content></ng-content>
  </mat-drawer-content>
</mat-drawer-container>
